<template>
  <div id="Index">

    <!-- NAVBAR -->
    <nav id="navi">
      <a class="navbar-brand" href="#">
        <img
          id="iconLogo"
          :src="require('../assets/images/logoMonPermis.png')"
          alt="MonPermis logo"
        />
      </a>
      <div class="nav-links" v-if="!maintenanceMode">
        <router-link to="/Connexion">
          <button class="btn-inscription">Inscription</button>
        </router-link>
        <router-link to="/Connexion">
          <button class="btn-connexion">Connexion</button>
        </router-link>
      </div>
    </nav>

    <!-- HERO -->
    <header id="hero">
      <div class="hero-decorations" aria-hidden="true">
        <div class="d2-tri1"></div>
        <div class="d2-tri2"></div>
        <div class="d2-rect1"></div>
        <div class="d2-rect2"></div>
        <div class="d2-line"></div>
      </div>
      <div class="hero-inner">
        <div class="hero-text">
          <span class="hero-badge">🚗 Auto-école en ligne</span>
          <h1 class="hero-title">
            Passez votre permis<br />
            <span class="hero-accent">en ligne</span> ou dans<br />
            l'une de nos agences
          </h1>
          <p class="hero-sub">
            Dossier, code, conduite : tout se gère depuis chez vous, simplement.
          </p>
          <div class="hero-cta" v-if="!maintenanceMode">
            <router-link to="/Connexion">
              <button class="btn-primary-lg">Je m'inscris gratuitement</button>
            </router-link>
          </div>
        </div>
        <div class="hero-visual">
          <div class="hero-img-wrapper">
            <img
              id="imgHeader"
              :src="require('../assets/images/imageAccueilModified3.png')"
              alt="Illustration permis en ligne"
            />
          </div>
        </div>
      </div>
      <div class="hero-wave">
        <svg viewBox="0 0 1440 80" preserveAspectRatio="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M0,40 C360,80 1080,0 1440,40 L1440,80 L0,80 Z" fill="#f4f6f9"/>
        </svg>
      </div>
    </header>

    <!-- FEATURES -->
    <section id="features" class="section">
      <div class="section-inner">
        <div class="section-header reveal reveal-up">
          <p class="section-head">FONCTIONNALITES</p>
          <h2 class="section-title">Tout se passe en ligne</h2>
          <p class="section-sub">De l'inscription à l'édition de votre permis, sans vous déplacer.</p>
        </div>
        <div class="features-grid">
          <div class="feature-card reveal reveal-up" style="--delay: 0ms">
            <div class="feature-icon" style="background: #e8f7f1; color: #e1f5ee;">📋</div>
            <h3>Dossier d'inscription</h3>
            <p>Remplissez et envoyez votre dossier entièrement en ligne, sans vous déplacer.</p>
          </div>
          <div class="feature-card reveal reveal-up" style="--delay: 80ms">
            <div class="feature-icon" style="background: #eef2ff; color: #fce8f3;">💡</div>
            <h3>Tests de code</h3>
            <p>Entraînez-vous et passer votre examen du code de la route.</p>
          </div>
          <div class="feature-card reveal reveal-up" style="--delay: 160ms">
            <div class="feature-icon" style="background: #fce8f3; color: #fef3c7;">📅</div>
            <h3>Réservation des heures</h3>
            <p>Choisissez vos créneaux horaires avec votre moniteur en quelques clics.</p>
          </div>
          <div class="feature-card reveal reveal-up" style="--delay: 0ms">
            <div class="feature-icon" style="background: #eef2ff; color: #fce8f3;">🎯</div>
            <h3>Réservation des examens</h3>
            <p>Code et conduite : planifiez vos examens en quelques clics.</p>
          </div>
          <div class="feature-card reveal reveal-up" style="--delay: 80ms">
            <div class="feature-icon" style="background: #fce8f3; color: #fef3c7;">🪪</div>
            <h3>Édition du permis</h3>
            <p>Obtenez votre permis et suivez son édition depuis votre espace personnel.</p>
          </div>
          <div class="feature-card reveal reveal-up" style="--delay: 160ms">
            <div class="feature-icon" style="background: #e8f7f1; color: #e1f5ee;">🪪</div>
            <h3>Suivi en temps réel</h3>
            <p>Visualisez l'avancement de votre formation et vos heures de conduite à tout moment.</p>
          </div>
        </div>
      </div>
    </section>

    <!-- FORFAIT -->
    <section class="section section-alt">
      <div class="section-inner">
        <div class="forfait-card reveal reveal-up">
          <div class="forfait-left">
            <p class="forfait-label">Notre offre phare</p>
            <h2 class="forfait-title">Formation au permis B<br /><span style="color: #6899f5;">1 380 €</span></h2>
            <ul class="forfait-list">
              <li>✅ Dossier d'inscription</li>
              <li>✅ Code de la route</li>
              <li>✅ 21 heures de conduite</li>
            </ul>
            <router-link to="/Connexion" v-if="!maintenanceMode">
              <button class="btn-primary-lg" style="margin-top: 28px;">Je commence maintenant</button>
            </router-link>
          </div>
          <div class="forfait-right">
            <img id="imgMain" :src="require('../assets/images/main.png')" alt="Application mobile" />
          </div>
        </div>
      </div>
    </section>

    <!-- AGENCES -->
    <section class="section">
      <div class="section-inner">
        <div class="section-header reveal reveal-up">
          <h2 class="section-title">Nos agences</h2>
          <p class="section-sub">Retrouvez-nous aussi en présentiel.</p>
        </div>
        <div class="agences-grid">
          <div class="agence-card reveal reveal-left">
            <div class="agence-icon">📍</div>
            <div class="agence-info">
              <h3>CER Garibaldi</h3>
              <p>47 Avenue Félix Faure — 69003 Lyon</p>
              <a href="tel:0983971818" class="agence-contact">09 83 97 18 18</a>
              <a href="mailto:cergaribaldi@gmail.com" class="agence-contact">cergaribaldi@gmail.com</a>
            </div>
          </div>
          <div class="agence-card reveal reveal-right">
            <div class="agence-icon">📍</div>
            <div class="agence-info">
              <h3>CER Saint-Fons</h3>
              <p>12 Avenue Gabriel Peri — 69190 Saint-Fons</p>
              <a href="tel:0951570357" class="agence-contact">09 51 57 03 57</a>
              <a href="mailto:cersaintfons69@gmail.com" class="agence-contact">cersaintfons69@gmail.com</a>
            </div>
          </div>
        </div>
        <div class="agence-tel-img reveal reveal-up">
          <img :src="require('../assets/images/tel.png')" alt="Téléphone" />
        </div>
      </div>
    </section>

    <!-- PARCOURS -->
    <section class="section section-alt parcours-section">
      <div class="section-inner">
        <div class="section-header reveal reveal-up">
          <h2 class="section-title">Votre parcours</h2>
          <p class="section-sub">Étape par étape, on vous accompagne jusqu'au permis.</p>
        </div>
        <div class="parcours-img-wrap reveal reveal-up">
          <img id="imgParcours" :src="require('../assets/images/parcours.png')" alt="Parcours MonPermis" />
        </div>
      </div>
    </section>

    <!-- FOOTER -->
    <footer id="footer">
      <div class="footer-inner">
        <img :src="require('../assets/images/logoMonPermis.png')" alt="Logo MonPermis" style="height: 40px; margin-bottom: 12px;" />
        <p>© 2024 MonPermis.fr — Tous droits réservés</p>
      </div>
    </footer>

    <!-- DIALOG: Avertissement Firefox -->
    <Dialog
      header="Information !"
      v-model:visible="displayAvertissement"
      :style="{ width: '50vw' }"
    >
      <div id="avertissement">
        <h2>
          Afin de pouvoir <strong>utiliser</strong> toutes les fonctionnalités
          de monpermis.fr, nous vous demandons de bien vouloir utiliser un autre
          navigateur que Firefox.
        </h2>
        <img
          class="mt-5"
          :src="require('../assets/images/logoMonPermis.png')"
          style="width: 30%; display: block; margin: 20px auto 0;"
          alt="Logo"
        />
        <button class="btn-primary-lg" style="margin-top: 24px;" @click="displayAvertissement = false">
          Je comprends
        </button>
      </div>
    </Dialog>

    <!-- DIALOG: Mise à jour -->
    <Dialog
      v-model:visible="visible"
      modal
      :style="{ width: '75vw', maxWidth: '480px' }"
    >
      <template #header>
        <div class="maintenance-header">
          <img
            :src="require('../assets/images/logoMonPermis.png')"
            class="maintenance-logo"
            alt="Logo MonPermis"
          />
          <span class="maintenance-header-title">Mise à jour de monpermis.fr</span>
        </div>
      </template>
      <div class="maintenance-dialog">
        <div class="maintenance-icon">
          <svg width="42" height="42" viewBox="0 0 24 24" fill="none" stroke="#6899f5" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
            <circle cx="12" cy="12" r="3"/>
            <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 4.68 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 9 4.68a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 2.83l-.06.06A1.65 1.65 0 0 0 19.4 9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z"/>
          </svg>
        </div>
        <p class="maintenance-text">
          Nous sommes actuellement en train de travailler sur une mise à jour de monpermis.fr.<br />
          Toutes nos excuses pour la gêne occasionnée, le site sera de nouveau disponible très prochainement !
        </p>
      </div>
    </Dialog>

  </div>
</template>

<script>
import jwt_decode from "jwt-decode";

export default {
  name: "Home",
  
  data() {
    return {
      displayAvertissement: false,
      visible: false,
      // Passer à true pour masquer tous les boutons Inscription/Connexion (ex: pendant une maintenance)
      maintenanceMode: false,
    };
  },

  components: {},

  mounted() {
    // Affiche le dialog de maintenance si le mode maintenance est activé
    this.visible = this.maintenanceMode;

    // Authentification token check
    let token = localStorage.getItem("user_access");
    if (token != null) {
      token = token.substring(1);
      token = token.substring(0, token.length - 1);
      let user = jwt_decode(token);
      let dateNow = new Date(Date.now());
      let dateExp = new Date(user.exp * 1000);
      if (dateExp > dateNow) {
        this.$store.commit("setUser", user);
        this.$store.commit("setToken", token);
        this.$router.push("/home");
      }
    }

    // Scroll reveal via Intersection Observer
    this._revealObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const el = entry.target;
            const delay = el.style.getPropertyValue("--delay") || "0ms";
            setTimeout(() => {
              el.classList.add("is-visible");
            }, parseInt(delay) || 0);
            this._revealObserver.unobserve(el);
          }
        });
      },
      { threshold: 0.12 }
    );

    document.querySelectorAll(".reveal").forEach((el) => {
      this._revealObserver.observe(el);
    });
  },

  beforeUnmount() {
    if (this._revealObserver) {
      this._revealObserver.disconnect();
    }
  },

  methods: {
    displayPopUp() {
      this.displayAvertissement = true;
    },
    track() {
      this.$gtag.pageview({ page_path: "/index" });
      this.$gtag.pageview("/index");
      this.$gtag.pageview(this.$route);
    },
  },
};
</script>

<style scoped>

/* DIALOG: Mise à jour */
.maintenance-dialog {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 8px 0 4px;
}

.maintenance-icon svg {
  animation: maintenance-wiggle 1.4s ease-in-out infinite;
  transform-origin: center;
}

@keyframes maintenance-wiggle {
  0%, 100% { transform: rotate(-8deg); }
  50% { transform: rotate(8deg); }
}

.maintenance-header {
  display: flex;
  align-items: center;
  gap: 10px;
}

.maintenance-logo {
  width: 32px;
  height: 32px;
  object-fit: contain;
}

.maintenance-header-title {
  font-weight: 600;
  font-size: 1.25rem;
}

.maintenance-text {
  font-size: 15px;
  line-height: 1.6;
  color: #4b5563;
  max-width: 380px;
}

*, *::before, *::after {
  box-sizing: border-box;
}

#Index {
  color: #1a1f2e;
  background: #f4f6f9;
  min-height: 100vh;
  overflow-x: hidden;
}

a {
  text-decoration: none;
}

/* ===================== SCROLL REVEAL ===================== */

/* État initial — invisible */
.reveal {
  opacity: 0;
  transition: opacity 0.6s ease, transform 0.6s ease;
  will-change: opacity, transform;
}

.reveal.reveal-up    { transform: translateY(32px); }
.reveal.reveal-left  { transform: translateX(-40px); }
.reveal.reveal-right { transform: translateX(40px); }

/* État final — visible */
.reveal.is-visible {
  opacity: 1;
  transform: translate(0, 0);
}

/* ===================== NAVBAR ===================== */
#navi {
  background: #ffffff;
  border-bottom: 1px solid #e2e8f0;
  padding: 0 32px;
  height: 64px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: sticky;
  top: 0;
  z-index: 300;
  box-shadow: 0 1px 3px rgba(0,0,0,0.06);
}

#iconLogo {
  height: 44px;
  width: auto;
}

.nav-links {
  display: flex;
  align-items: center;
  gap: 10px;
}

.btn-inscription {
  padding: 9px 20px;
  border-radius: 10px;
  border: 1.5px solid #6899f5;
  background: transparent;
  color: #6899f5;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.15s;
}

.btn-inscription:hover {
  background: #6899f5;
  color: #fff;
}

.btn-connexion {
  padding: 9px 20px;
  border-radius: 10px;
  border: none;
  background: #6899f5;
  color: #fff;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.15s;
}

.btn-connexion:hover {
  background: #407EF1;
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(7, 152, 159, 0.3);
}

/* ===================== HERO ===================== */
#hero {
  background: linear-gradient(135deg, #4a35cc 0%, #6899f5 100%);
  position: relative;
  overflow: hidden;
  padding-bottom: 0;
  
}

/* ===================== HERO DECORATIONS ===================== */
.hero-decorations {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  z-index: 0;
  
}

.d2-tri1 {
  position: absolute;
  top: -3%;
  right: 17%;
  width: 0;
  height: 0;
  border-left: 140px solid transparent;
  border-right: 140px solid transparent;
  border-bottom: 210px solid rgba(255, 255, 255, 0.027);
}

.d2-tri2 {
  position: absolute;
  bottom: 10%;
  right: -1%;
  width: 0;
  height: 0;
  border-left: 110px solid transparent;
  border-right: 110px solid transparent;
  border-bottom: 160px solid rgba(255, 255, 255, 0.027);
}

.d2-rect1 {
  position: absolute;
  top: 60px;
  right: 130px;
  width: 390px;
  height: 390px;
  border: 1.5px solid rgba(255, 255, 255, 0.12);
  border-radius: 4px;
  transform: rotate(18deg);
}

.d2-rect2 {
  position: absolute;
  bottom: 100px;
  left: 30%;
  width: 100px;
  height: 100px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 4px;
  transform: rotate(-12deg);
}

.d2-line {
  position: absolute;
  top: 0;
  bottom: 0;
  right: 500px;
  width: 1px;
  background: linear-gradient(
    to bottom,
    transparent,
    rgba(255, 255, 255, 0.15),
    transparent
  );
}

.hero-inner {
  max-width: 1200px;
  margin: 0 auto;
  padding: 72px 32px 40px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 48px;
  height: 65vh;

}

.hero-text {
  flex: 1;
  max-width: 540px;
}

.hero-badge {
  display: inline-block;
  background: #6899f5;
  color: #FFFFFF;
  border-radius: 20px;
  padding: 6px 16px;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.05em;
  margin-bottom: 20px;
}

.hero-title {
  font-size: 52px;
  font-weight: 400;
  line-height: 1.15;
  color: #1a1f2e;
  margin-bottom: 20px;
  letter-spacing: -0.5px;
  text-align: left;
}

.hero-accent {
  color: #FFFFFF;
}

.hero-sub {
  font-size: 17px;
  color: #FFFFFF;
  line-height: 1.6;
  margin-bottom: 36px;
  text-align: left;
}

.hero-cta {
  display: flex;
  align-items: center;
  gap: 20px;
  flex-wrap: wrap;
}

.btn-primary-lg {
  display: inline-flex;
  align-items: center;
  padding: 14px 28px;
  border-radius: 12px;
  border: none;
  background: #6899f5;
  color: #fff;
  font-size: 15px;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.2s;
  box-shadow: 0 4px 16px rgba(104, 153, 245, 0.35);
}

.btn-primary-lg:hover {
  background: #4d7ef0;
  transform: translateY(-2px);
  box-shadow: 0 8px 24px rgba(104, 153, 245, 0.45);
}

.link-discover {
  color: #6899f5;
  font-weight: 600;
  font-size: 15px;
  transition: color 0.15s;
}

.link-discover:hover {
  color: #4d7ef0;
}

.hero-visual {
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: flex-end;
  max-width: 520px;
}

.hero-img-wrapper {
  position: relative;
}

#imgHeader {
  width: 100%;
  max-width: 500px;
  max-height: 420px;
  object-fit: contain;
  display: block;
}

.hero-wave {
  width: 100%;
  line-height: 0;
}

.hero-wave svg {
  width: 100%;
  height: 80px;
}

/* ===================== SECTIONS ===================== */
.section {
  padding: 80px 32px;
  background: #f4f6f9;
  text-align: left;
}

.section-alt {
  background: #ffffff;
}

.section-inner {
  max-width: 1200px;
  margin: 0 auto;
}

.section-header {
  text-align: left;
  margin-bottom: 48px;
}

p.section-head{
  color: #df6fa8;
  font-size: 15px;
}

.section-title {
  font-size: 30px;
  font-weight: bold;
  color: #6899f5;
  margin-bottom: 10px;
  letter-spacing: -0.3px;
}

.section-sub {
  font-size: 15px;
  color: #64748b;
}

/* ===================== FEATURES GRID ===================== */
.features-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;
}

.feature-card {
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 16px;
  padding: 28px 24px;
  transition: transform 0.2s, box-shadow 0.2s, opacity 0.6s ease;
}

.feature-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 8px 24px rgba(0,0,0,0.1);
}

/* On surcharge le transform du hover uniquement quand la carte est visible */
.feature-card.reveal-up:not(.is-visible) {
  transform: translateY(32px);
}

.feature-icon {
  width: 48px;
  height: 48px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 22px;
  margin-bottom: 16px;
}

.feature-card h3 {
  font-size: 16px;
  font-weight: 700;
  color: #1a1f2e;
  margin-bottom: 8px;
}

.feature-card p {
  font-size: 13px;
  color: #64748b;
  line-height: 1.5;
}

/* ===================== FORFAIT ===================== */
.forfait-card {
  background: linear-gradient(135deg, #eef2ff 0%, #e0f7f8 100%);
  border: 1px solid #e2e8f0;
  border-radius: 24px;
  padding: 56px 48px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 48px;
  box-shadow: 0 4px 24px rgba(0,0,0,0.07);
}

.forfait-left {
  flex: 1;
  max-width: 480px;
}

.forfait-label {
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: #6899f5;
  margin-bottom: 12px;
}

.forfait-title {
  font-size: 44px;
  font-weight: 400;
  line-height: 1.2;
  color: #1a1f2e;
  margin-bottom: 24px;
}

.forfait-list {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.forfait-list li {
  font-size: 16px;
  color: #1a1f2e;
  font-weight: 500;
}

.forfait-right {
  flex-shrink: 0;
}

#imgMain {
  height: 220px;
  width: auto;
  object-fit: contain;
  display: block;
}

/* ===================== AGENCES ===================== */
.agences-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;
  margin-bottom: 40px;
}

.agence-card {
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 16px;
  padding: 28px 24px;
  display: flex;
  align-items: flex-start;
  gap: 16px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.05);
  transition: transform 0.2s, opacity 0.6s ease;
}

.agence-card:hover {
  transform: translateY(-3px);
}

.agence-icon {
  font-size: 28px;
  flex-shrink: 0;
  width: 48px;
  height: 48px;
  background: #eef2ff;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.agence-info h3 {
  font-size: 17px;
  font-weight: 700;
  color: #1a1f2e;
  margin-bottom: 6px;
}

.agence-info p {
  font-size: 14px;
  color: #64748b;
  margin-bottom: 10px;
}

.agence-contact {
  display: block;
  font-size: 14px;
  color: #6899f5;
  font-weight: 600;
  margin-bottom: 4px;
  transition: color 0.15s;
}

.agence-contact:hover {
  color: #4d7ef0;
}

.agence-tel-img {
  display: flex;
  justify-content: center;
  margin-top: 8px;
}

.agence-tel-img img {
  max-width: 200px;
  opacity: 0.85;
}

/* ===================== PARCOURS ===================== */
.parcours-img-wrap {
  text-align: center;
}

#imgParcours {
  width: 100%;
  max-width: 900px;
  border-radius: 16px;
}

/* ===================== FOOTER ===================== */
#footer {
  background: #1a1f2e;
  padding: 40px 32px;
}

.footer-inner {
  max-width: 1200px;
  margin: 0 auto;
  text-align: center;
}

.footer-inner p {
  color: #94a3b8;
  font-size: 13px;
}

/* ===================== DIALOG ===================== */
#avertissement {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}

/* ===================== RESPONSIVE — TABLET ===================== */
@media (max-width: 960px) {
  .hero-inner {
    flex-direction: column;
    padding: 48px 24px 32px;
    text-align: center;
  }

  .hero-text {
    max-width: 100%;
  }

  .hero-title {
    font-size: 38px;
  }

  .hero-cta {
    justify-content: center;
  }

  .hero-visual {
    max-width: 100%;
  }

  #imgHeader {
    max-width: 320px;
    max-height: 280px;
  }

  .features-grid {
    grid-template-columns: repeat(2, 1fr);
  }

  .forfait-card {
    flex-direction: column;
    padding: 36px 28px;
    gap: 32px;
  }

  .forfait-title {
    font-size: 34px;
  }

  .agences-grid {
    grid-template-columns: 1fr;
  }

  .section {
    padding: 56px 24px;
  }

  .section-title {
    font-size: 30px;
  }
}

/* ===================== RESPONSIVE — MOBILE ===================== */
@media (max-width: 500px) {
  #navi {
    padding: 0 16px;
    height: 56px;
  }

  #iconLogo {
    height: 36px;
  }

  .btn-inscription,
  .btn-connexion {
    padding: 7px 14px;
    font-size: 12px;
  }

  .hero-title {
    font-size: 28px;
  }

  .hero-sub {
    font-size: 15px;
  }

  .hero-title,
  .hero-sub {
    text-align: center;
  }

  .hero-cta {
    justify-content: center;
  }



  .btn-primary-lg {
    font-size: 14px;
    padding: 12px 22px;
  }

  .features-grid {
    grid-template-columns: 1fr;
  }

  .forfait-card {
    padding: 28px 20px;
    gap: 24px;
  }

  .forfait-title {
    font-size: 28px;
  }

  #imgMain {
    height: 150px;
  }

  .section {
    padding: 48px 16px;
  }

  .section-title {
    font-size: 26px;
  }

  .agence-card {
    padding: 20px 16px;
  }

  #imgParcours {
    border-radius: 10px;
  }

  .hero-badge {
    font-size: 11px;
  }
}
</style>